// avstemming-tax-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avg.common.ofCount': '{done} of {total}',
  'avg.derived.betaling_mangler': 'Overdue claims without payment have been handled',
  'avg.derived.betalt_for_sent': 'Claims paid after the due date have been handled',
  'avg.derived.delvis_betalt': 'Partially paid claims have been handled',
  'avg.derived.bokforingsdifferanse': 'Differences between claims and booked liabilities have been handled',
  'avg.derived.ikke_bokfort': 'Claims without a booked liability have been handled',
  'avg.derived.ikke_meldt': 'Payroll runs not registered as reported have been handled',
  'avg.derived.mva_ikke_levert': 'VAT settlements that are not finalised have been handled',
  'avg.derived.direktefort': 'Direct postings on the control accounts have been assessed',
  'avg.derived.uten_bankdekning': 'Payments not confirmed in the bank statement have been handled',
  'avg.checklist.title': 'Professional checklist',
  'avg.checklist.titleReadOnly': 'Professional checklist (performer\'s, read-only)',
  'avg.checklist.empty': 'No control points are defined for tax and public charges in this period.',
  'avg.checklist.intro': 'The points apply to the whole tax area. A tick is saved on all the control accounts in the period.',
  'avg.checklist.groupItems': 'Items that require handling',
  'avg.checklist.processed': '{done} of {total} handled',
  'avg.checklist.notRelevant': 'Not applicable this period',
  'avg.checklist.autoTag': 'Follows from the assessments',
  'avg.checklist.groupAssessment': 'Overall professional assessments',
  'avg.checklist.groupReady': 'Readiness',
  'avg.checklist.performedBy': 'Performed by {name}',
  'avg.checklist.completed': '{done} of {total} control points completed',
  'avg.blocker.itemsOne': '{count} item requires assessment',
  'avg.blocker.itemsMany': '{count} items require assessment',
  'avg.blocker.accounts': 'Control accounts deviating from the calculated basis: {count}',
  'avg.blocker.overdue': 'Overdue claims not paid: {count}',
  'avg.blocker.controlsOne': '{count} control point remains',
  'avg.blocker.controlsMany': '{count} control points remain',
  'avg.concl.title': 'Conclusion and approval',
  'avg.concl.label': 'Conclusion',
  'avg.concl.placeholder': 'What does the review of tax and public charges show for this period?',
  'avg.concl.savedAs': 'Saved as the justification on the control point "{label}".',
  'avg.concl.remainingRisk': 'Remaining risk',
  'avg.concl.noBlockers': 'Nothing remains that prevents the area from being sent for review. The claims overview from Skatteetaten has not been fetched — the reconciliation was done against the company\'s own calculated claims.',
  'avg.concl.followUpTitle': 'Follow-up next period',
  'avg.concl.followUpEmpty': 'No assessments are marked for follow-up next period.',
  'avg.concl.followUpBadge': 'Follow-up',
  'avg.concl.measure': 'Action: {value}',
  'avg.concl.noMeasure': 'No action noted',
  'avg.concl.deadline': 'Deadline {date}',
  'avg.concl.openAssessment': 'Open assessment',
  'avg.concl.sendToControl': 'Send the area for review',
  'avg.concl.oneLeft': 'One thing remains before the area can be sent.',
  'avg.concl.manyLeft': '{count} things remain before the area can be sent.',
  'avg.common.close': 'Close',
  'avg.common.requestDocs': 'Ask the client for documentation',
  'avg.common.status': 'Status',
  'avg.common.viewAssessment': 'View assessment',
  'avg.common.assess': 'Assess',
  'avg.common.openPayroll': 'Open payroll reconciliation',
  'avg.common.openVat': 'Open VAT reconciliation',
  'avg.col.booked': 'Booked',
  'avg.col.paid': 'Paid',
  'avg.col.rest': 'Remainder',
  'avg.col.assessment': 'Assessment',
  'avg.col.due': 'Due date',
  'avg.col.period': 'Period',
  'avg.col.difference': 'Difference',
  'avg.col.details': 'Details',
  'avg.col.date': 'Date',
  'avg.col.amount': 'Amount',
  'avg.col.claim': 'Claim',
  'avg.drawer.due': 'Due {date}',
  'avg.drawer.calculatedClaim': 'Calculated claim',
  'avg.drawer.rationale': 'Professional justification',
  'avg.drawer.rationaleRequired': 'Professional justification (required)',
  'avg.drawer.rationalePlaceholder': 'What does the matter concern, and what is the assessment based on?',
  'avg.drawer.measure': 'Action',
  'avg.drawer.measurePlaceholder': 'E.g. Pay the claim, correct the liability on the voucher, or ask for documentation',
  'avg.drawer.followUpDeadline': 'Follow-up deadline',
  'avg.drawer.followUpNext': 'Follow up next period',
  'avg.drawer.needsRationale': 'This assessment requires a justification.',
  'avg.drawer.save': 'Save assessment',
  'avg.status.incomplete': 'Incomplete',
  'avg.sources.title': 'Data sources',
  'avg.sources.missingOne': '{count} source is not complete for the period.',
  'avg.sources.missingMany': '{count} sources are not complete for the period.',
  'avg.sources.allPresent': 'The sources the reconciliation reads are in place for the period.',
  'avg.sources.source': 'Source',
  'avg.sources.unavailable': 'Not available',
  'avg.sources.complete': 'Complete',
  'avg.main.title': 'Automatic main reconciliation',
  'avg.main.noAccount': 'No control account with a calculated basis',
  'avg.main.differenceOpen': 'Difference must be handled',
  'avg.main.matches': 'Booked liability matches the claims',
  'avg.main.bookedBalance': 'Booked balance on control accounts',
  'avg.main.claims': 'Calculated and unpaid claims',
  'avg.main.preliminaryDiff': 'Preliminary difference',
  'avg.main.explained': 'Explained items in the reconciliation',
  'avg.main.unexplained': 'Unexplained difference',
  'avg.main.comparedOn': 'Compared on {accounts}.',
  'avg.main.explainer': 'The claims are the company\'s own calculated obligations from payroll and VAT, with statutory due dates. The claims overview from Skatteetaten is not fetched by the app.',
  'avg.main.openClaims': 'Open public claims',
  'avg.main.dueSoon': 'Due in the next 14 days',
  'avg.main.overdue': 'Overdue at period end',
  'avg.main.paidInPeriod': 'Paid in the period',
  'avg.main.directPostings': 'Direct postings on control accounts',
  'avg.main.claimsNoLiability': 'Claims without booked liability',
  'avg.main.openClaimsOverview': 'Open claims overview',
  'avg.main.seePayments': 'See payments',
  'avg.main.seeAccounts': 'See control accounts',
  'avg.accounts.title': 'Control accounts in the general ledger',
  'avg.accounts.empty': 'No control account for tax and public charges exists in this period.',
  'avg.accounts.status.stemmer': 'Matches',
  'avg.accounts.status.ikke_sammenliknet': 'Not compared',
  'avg.accounts.status.ikke_relevant': 'Not relevant',
  'avg.accounts.colAccount': 'Control account',
  'avg.accounts.colOpening': 'Opening balance',
  'avg.accounts.colDebit': 'Debit',
  'avg.accounts.colCredit': 'Credit',
  'avg.accounts.colClosing': 'Closing balance',
  'avg.accounts.colBasis': 'Calculated basis',
  'avg.accounts.openAccount': 'Open account',
  'avg.tile.betaling_mangler': 'Overdue claims without payment',
  'avg.tile.betalt_for_sent': 'Paid after due date',
  'avg.tile.bokforingsdifferanse': 'Booking difference against the claim',
  'avg.tile.ikke_bokfort': 'Claims without booked liability',
  'avg.tile.delvis_betalt': 'Partially paid claims',
  'avg.tile.ikke_meldt': 'Payroll run not registered as reported',
  'avg.tile.mva_ikke_levert': 'VAT settlement not finalised',
  'avg.tile.direktefort': 'Direct postings on control account',
  'avg.tile.uten_bankdekning': 'Payment without bank coverage',
  'avg.tile.betalt_etter_periode': 'Paid after period end',
  'avg.ctl.title': 'Control card',
  'avg.ctl.checksRun': 'Automatic checks run: {count}',
  'avg.ctl.flagged': 'Items requiring assessment: {count}',
  'avg.ctl.done': 'Fully assessed: {count}',
  'avg.ctl.accountsVsClaims': 'Control accounts against claims',
  'avg.ctl.reconciledOf': '{done} of {total} reconciled',
  'avg.ctl.accountsWithBasis': 'Accounts with a calculated basis',
  'avg.ctl.activeFilter': 'Active filter: {label}',
  'avg.ctl.postsCount': 'Entries: {count}',
  'avg.ctl.reset': 'Reset',
  'avg.checks.title': 'Automatic checks',
  'avg.checks.intro': 'The checks do not tick anything in the professional checklist. They say what the person ticking should have looked at.',
  'avg.checks.colCheck': 'Check',
  'avg.checks.colRun': 'Run',
  'avg.checks.colFindings': 'Findings',
  'avg.checks.ran': 'Run',
  'avg.checks.findings': 'Findings: {count}',
  'avg.checks.none': 'No findings',
  'avg.common.yes': 'Yes',
  'avg.common.no': 'No',
  'avg.claims.titleEmpty': 'Public claims in the period',
  'avg.claims.empty': 'The period has no calculated public obligations. Without payroll runs and without a VAT term there are no claims to reconcile.',
  'avg.claims.title': 'Public claims — calculated, booked and paid',
  'avg.claims.intro': 'The claims are the company\'s own calculated obligations with statutory due dates. The amount comes from the payroll run and the VAT return, not from a claims overview at Skatteetaten — the app does not fetch it.',
  'avg.claims.colType': 'Claim type',
  'avg.claims.colCalculated': 'Calculated',
  'avg.claims.colBookedLiability': 'Booked liability',
  'avg.claims.colPayment': 'Payment',
  'avg.claims.colBooking': 'Booking',
  'avg.claims.draftCredit': 'Draft: {amount} receivable',
  'avg.claims.draftPayable': 'Draft: {amount} payable',
  'avg.claims.openVat': 'Open VAT',
  'avg.wh.title': 'Withholding tax — payment after salary payout',
  'avg.wh.runsWithWithholding': 'Payroll runs with withholding tax',
  'avg.wh.totalWithholding': 'Total withholding tax',
  'avg.wh.paidInTime': 'Paid within the deadline',
  'avg.wh.overdueUnpaid': 'Overdue without payment',
  'avg.wh.paidLate': 'Paid after the deadline',
  'avg.wh.colRun': 'Payroll run',
  'avg.wh.colPayDate': 'Pay date',
  'avg.wh.colWithholding': 'Withholding tax',
  'avg.wh.colDeadline': 'Payment deadline',
  'avg.wh.colRegisteredPaid': 'Registered paid',
  'avg.wh.colPaymentDate': 'Payment date',
  'avg.wh.colAmelding': 'A-melding',
  'avg.wh.empty': 'No payroll run in the period has withholding tax to pay.',
  'avg.wh.note': 'From 2026, withholding tax and attachment deductions are paid directly to Skatteetaten no later than the first working day after the salary payout. The deadline above is calculated by the payroll model, with Norwegian public holidays. The payment is the one registered against the run — the KID from Skatteetaten is not fetched by the app.',
  'avg.aga.title': 'Employer\'s contribution and financial tax',
  'avg.aga.empty': 'No employer\'s contribution has been calculated for the term this period belongs to.',
  'avg.aga.computed': 'Calculated in the payroll system',
  'avg.aga.cost': 'Booked expense (5400)',
  'avg.aga.liability': 'Booked liability (2770)',
  'avg.aga.term': 'Term',
  'avg.aga.deadline': 'Payment deadline',
  'avg.aga.financeTax': 'Financial tax',
  'avg.aga.financeTaxNote': 'Not calculated by the payroll model',
  'avg.aga.bookingDifference': 'Booking difference',
  'avg.aga.noBooking': 'No booking to compare with',
  'avg.aga.matches': 'Booked contribution matches the calculation',
  'avg.aga.note': 'The movement is that of the term, from the start of the term to period end. The contribution accrues through the term, and the month alone would compare half the term\'s postings with the whole term\'s contribution.',
  'avg.aga.documentExplanation': 'Document explanation',
  'avg.vat.title': 'VAT and settlement',
  'avg.vat.empty': 'No VAT term covers this period.',
  'avg.vat.intro': 'The transaction checks for VAT are done in the VAT reconciliation — this section only shows the settlement status.',
  'avg.vat.reportingPeriod': 'Reporting period',
  'avg.vat.net': 'Net VAT in the term',
  'avg.vat.netCredit': '{amount} receivable',
  'avg.vat.netPayable': '{amount} payable',
  'avg.vat.settlementBalance': 'Booked on settlement account',
  'avg.vat.dueDate': 'Filing deadline',
  'avg.vat.registeredPaid': 'Registered paid',
  'avg.vat.termOver': 'The term ends in this period',
  'avg.ctax.title': 'Corporate tax and advance tax',
  'avg.ctax.payable': 'Tax payable (2500)',
  'avg.ctax.deferred': 'Deferred tax (2510)',
  'avg.ctax.prepaid': 'Advance tax (2540)',
  'avg.ctax.cost': 'Booked tax expense year to date (8300)',
  'avg.ctax.note': 'The tax provision is an accounting calculation. External reconciliation happens against the advance tax notice, the tax settlement or another claim from Skatteetaten — Plumme fetches none of them, and the accounts therefore appear as "not compared" in the control account table. The next relevant check is the annual closing or a new tax settlement.',
  'avg.flag.betaling_mangler': 'Overdue — not paid',
  'avg.flag.delvis_betalt': 'Partially paid',
  'avg.flag.betalt_for_sent': 'Paid after due date',
  'avg.flag.betalt_etter_periode': 'Paid after period end',
  'avg.flag.bokforingsdifferanse': 'Booking difference',
  'avg.flag.ikke_bokfort': 'Not booked as liability',
  'avg.flag.ikke_meldt': 'Payroll run not registered as reported',
  'avg.flag.mva_ikke_levert': 'VAT return not filed',
  'avg.flag.direktefort': 'Posted directly to control account',
  'avg.flag.uten_bankdekning': 'Payment not confirmed by the bank',
  'avg.assessment.ikke_vurdert': 'Not assessed',
  'avg.assessment.ingen_korrigering': 'No correction needed',
  'avg.assessment.tidsforskjell': 'Timing difference',
  'avg.assessment.feil_bokforing': 'Booking error',
  'avg.assessment.manglende_betaling': 'Missing payment',
  'avg.assessment.manglende_bokforing': 'Missing booking',
  'avg.assessment.feil_kobling': 'Wrong link to claim',
  'avg.assessment.tilbakebetaling': 'Refund or set-off',
  'avg.assessment.rente': 'Interest claim',
  'avg.assessment.bankgebyr': 'Fee',
  'avg.assessment.avventer_dokumentasjon': 'Awaiting documentation',
  'avg.assessment.avventer_klienten': 'Awaiting the client',
  'avg.assessment.ikke_relevant': 'Not relevant',
  'avg.assessment.neste_periode': 'Follow up next period',
  'avg.quick.krever_vurdering': 'Requires assessment',
  'avg.quick.all': 'All',
  'avg.quick.betaling_mangler': 'Payment missing',
  'avg.quick.betalt_for_sent': 'Paid too late',
  'avg.quick.bokforingsdifferanse': 'Booking difference',
  'avg.quick.ikke_bokfort': 'Not booked',
  'avg.quick.ikke_meldt': 'A-melding',
  'avg.quick.direktefort': 'Direct postings',
  'avg.quick.uten_bankdekning': 'Without bank coverage',
  'avg.quick.ferdig_vurdert': 'Fully assessed',
  'avg.quick.confirmed': 'Confirmed by the bank',
  'avg.quick.registrert': 'Registered against claim',
  'avg.quick.etter_frist': 'Paid after the deadline',
  'avg.quick.etter_periode': 'After period end',
  'avg.flagBadges.none': 'None',
  'avg.flagBadges.more': '+{count} more',
  'avg.match.registrert': 'Registered against claim',
  'avg.match.etter_frist': 'Registered — after due date',
  'avg.match.etter_periode': 'Registered — after period end',
  'avg.match.direktefort': 'Posted directly — no source accounts for it',
  'avg.pay.title': 'Payments and postings on the control accounts',
  'avg.pay.intro': 'The payments are the company\'s own registered settlements against the claims. If the payment is matched to a bank line in the bank reconciliation, it is the bank statement that confirms the money left the account — the only external source this area has. The direct postings are postings on the control accounts that come neither from a payroll run, a registered tax payment nor a VAT settlement — a fee, an interest charge or a manual correction.',
  'avg.pay.colDescription': 'Description',
  'avg.pay.colApplies': 'Applies to',
  'avg.pay.colBank': 'Bank coverage',
  'avg.pay.colVoucher': 'Voucher',
  'avg.pay.bankLine': 'Bank line {date}',
  'avg.pay.notMatched': 'Not matched',
  'avg.pay.noStatement': 'No bank statement',
  'avg.pay.empty': 'No payments or postings match the filters.',
  'avg.items.title': 'Deviations and actions',
  'avg.items.clearFilters': 'Clear filters',
  'avg.items.colMatter': 'Matter',
  'avg.items.colAlert': 'Alert',
  'avg.items.empty': 'No matters match the filters.',
  'avg.docs.notFetched': 'Not fetched by the app',
  'avg.docs.inPlace': 'In place',
  'avg.docs.title': 'Documentation',
  'avg.docs.colBasis': 'Basis',
  'avg.docs.requestFromCustomer': 'Ask the customer for documentation',
  'avg.docs.attached': 'Attached documentation',
  'avg.docs.attachedEmpty': 'No documents have been uploaded in the tax area for this period.',
  'avg.page.noAccount': 'The tax area has no reconciliation account in this period.',
  'avg.nav.differences': 'Differences: {count}',
  'avg.nav.matches': 'Matches',
  'avg.nav.overview': 'Overview',
  'avg.nav.claims': 'Claims and balance',
  'avg.nav.claimsCount': 'Claims: {count}',
  'avg.nav.withholding': 'Withholding tax',
  'avg.nav.toAssess': 'To assess: {count}',
  'avg.nav.runs': 'Runs: {count}',
  'avg.nav.aga': 'Employer\'s contribution',
  'avg.nav.oneDifference': '1 difference',
  'avg.nav.filed': 'Filed',
  'avg.nav.notFiled': 'Not filed',
  'avg.nav.corporateTax': 'Corporate tax',
  'avg.nav.noExternalSource': 'No external source',
  'avg.nav.payments': 'Payments',
  'avg.nav.entries': 'Entries: {count}',
  'avg.nav.open': 'Open: {count}',
  'avg.nav.missing': 'Missing: {count}',
  'avg.nav.controls': 'Review and approval',
  'avg.page.areaLabel': 'Tax and public charges',
  'avg.page.hintOpen': 'Items with alerts not fully assessed: {count}.',
  'avg.page.hintDone': 'All items with alerts have been assessed.',
  'avg.page.heading': 'Tax and public charges — claims, booking and payment',
  'avg.page.vatTerm': 'VAT term {n} ({period})',
  'avg.page.responsible': 'Responsible {name}',
  'avg.page.overdueBadge': 'Overdue claims without payment: {count}',
  'avg.page.noOpen': 'No open matters',
  'avg.page.claimsSource': 'The claims are taken from the payroll runs and the VAT return, with statutory due dates.',
  'avg.page.claimsChecked': 'Claims checked against the bookkeeping: {claims}. Items requiring assessment: {unassessed}.',
  'avg.page.notFetchedInfo': 'Plumme does not fetch the claims overview, balance or KID from Skatteetaten. The reconciliation compares the company\'s own calculated obligations with the bookkeeping and the registered payments. A claim assessed by Skatteetaten must be checked manually against the tax account.',
});
